import type { LocalCookies, LocalStorageFunctions } from './types';

const COOKIES: string = 'cookies';

const getLocalStorageCookies = (fn: LocalStorageFunctions) => () => fn.readObject<boolean>(COOKIES) === true;
const setLocalStorageCookies = (fn: LocalStorageFunctions) => () => fn.writeObject(COOKIES, true);

const cookies = (fn: LocalStorageFunctions): LocalCookies => ({
  getLocalStorageCookies: getLocalStorageCookies(fn),
  setLocalStorageCookies: setLocalStorageCookies(fn)
});

export default cookies;
